export const getStyles = () => ({
  shoppingSettings: {
    '& .control-label': {
      marginTop: 12,
    },

    '& .filteredProducts .helpbutton': {
      marginLeft: '6px !important',
    },

    '& .col-sm-offset-2': {
      marginLeft: 0,
    },

    '& .col-sm-6': {
      minWidth: 650,
    },
  },
});
